import { lazy } from 'react'

export const SosMessageVariant1 = lazy(() => import('./SosMessageVariant1'))
